import { render, staticRenderFns } from "./currency.vue?vue&type=template&id=2c68327a&scoped=true&"
import script from "./currency.vue?vue&type=script&lang=ts&"
export * from "./currency.vue?vue&type=script&lang=ts&"
import style0 from "./currency.vue?vue&type=style&index=0&id=2c68327a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c68327a",
  null
  
)

export default component.exports